import { FunctionComponent } from 'react';
import { useLocation } from 'react-router-dom';
import VerifyContact from './VerifyContact/VerifyContact';

type FC = FunctionComponent;

const RootContainer: FC = () => {
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const otp = queryParams.get('OTP');
  const emailToken = queryParams.get('emailVerificationToken');
  const phoneToken = queryParams.get('phoneVerificationToken');

  const verificationType = otp ? (emailToken ? 'email' : phoneToken ? 'phone' : null) : null;

  const token = verificationType === 'email' ? emailToken : phoneToken;

  return verificationType ? <VerifyContact verificationType={verificationType} token={token!} otp={otp!} /> : null;
};

export default RootContainer;
